export * from './analytics.service';
export * from './analytics.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/analytics/shared/index.ts